import { motion } from "framer-motion";
import { Leaf, Beef, HeartHandshake } from "lucide-react";

const ABOUT_IMG =
  "https://customer-assets.emergentagent.com/job_fresh-mezze/artifacts/8krs7b9m_IMG_0786.jpeg";

const POINTS = [
  { icon: Beef, title: "Fresh meat, always", text: "We cook with fresh, never-frozen meat prepared the same day." },
  { icon: Leaf, title: "Real ingredients", text: "Authentic spices, fresh produce, and family recipes." },
  { icon: HeartHandshake, title: "Made with care", text: "Small-batch, handmade dishes served like family." },
];

export const About = () => {
  return (
    <section id="about" data-testid="about-section" className="py-20 sm:py-28 bg-surface2">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        <motion.div
          initial={{ opacity: 0, x: -24 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="relative"
        >
          <img src={ABOUT_IMG} alt="Freshly grilled Iraqi and Middle Eastern dishes" className="rounded-3xl w-full h-[420px] object-cover shadow-xl" />
          <div className="absolute -bottom-5 -right-3 sm:-right-5 bg-brand text-white rounded-2xl px-6 py-4 shadow-lg">
            <p className="font-serif text-2xl font-bold leading-none">100%</p>
            <p className="text-xs uppercase tracking-widest">Fresh, never frozen</p>
          </div>
        </motion.div>

        <div>
          <span className="text-sm tracking-[0.25em] uppercase text-brand font-bold">Our Story</span>
          <h2 className="mt-3 font-serif text-3xl sm:text-4xl lg:text-5xl font-bold text-ink">
            A taste of Iraq in Charlottesville
          </h2>
          <p className="mt-5 text-inkmuted leading-relaxed">
            KitchenBox started with a simple belief: great food is fresh food. From our
            slow-roasted Qoozi and hand-rolled dolma to warm kahi with clotted cream and syrup-soaked
            knafeh, every dish is made to order with fresh meat and authentic Iraqi &amp; Middle Eastern
            ingredients — the way our family has always cooked.
          </p>
          <div className="mt-8 space-y-5">
            {POINTS.map((p) => (
              <div key={p.title} className="flex gap-4">
                <div className="w-11 h-11 shrink-0 rounded-xl bg-brand/10 text-brand flex items-center justify-center">
                  <p.icon size={20} />
                </div>
                <div>
                  <h3 className="font-serif text-lg font-semibold text-ink">{p.title}</h3>
                  <p className="text-sm text-inkmuted">{p.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
